import { render, staticRenderFns } from "./CreateSalaries.vue?vue&type=template&id=121186f3&scoped=true"
import script from "./CreateSalaries.vue?vue&type=script&lang=js"
export * from "./CreateSalaries.vue?vue&type=script&lang=js"
import style0 from "./CreateSalaries.vue?vue&type=style&index=0&id=121186f3&prod&scoped=true&lang=css"
import style1 from "./CreateSalaries.vue?vue&type=style&index=1&id=121186f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121186f3",
  null
  
)

export default component.exports